import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../../../routes';

/**
 * Where the header's secondary links went.
 *
 * Contact Us, Register, Privacy & Data Policy and Guarantee used to sit in the
 * shared nav's top-right utility row, competing for space with the cart — which
 * is how "Privacy & Data Policy" ended up truncated to "Privacy & Data Po…" and
 * overlapping the cart icon. None of them is something a customer reaches for
 * mid-purchase, so they belong at the bottom of the page.
 *
 * Scoped to this page like GiftHeader: the site's other 71 customer routes still
 * carry those links in the shared nav.
 */

const DOMAIN_SOUTH = 'https://www.shoobphotosouth.com/contact1';

// Same host test the shared nav uses, so the Contact link resolves to the same
// place on shoob.cloud as it does everywhere else on the site.
const contactHref = () => (
  window.location.hostname.includes('shoob.cloud') ? DOMAIN_SOUTH : '/contacts/new'
);

const LINK = 'inline-flex items-center text-[14px] font-medium text-gift-inkSoft '
  + 'no-underline transition hover:text-gift-accent';

export default function GiftFooter() {
  return (
    <footer className="mt-16 border-0 border-t border-solid border-gift-line">
      <div className="mx-auto flex max-w-[1440px] flex-wrap items-center gap-x-8 gap-y-2 px-5 py-6 md:px-10 lg:px-16">
        <a className={LINK} href={contactHref()}>Contact Us</a>
        <Link className={LINK} to={routes.registration()}>Register</Link>
        <a className={LINK} href="/privacy-policy">Privacy &amp; Data Policy</a>
        <a className={LINK} href="/guarantee">Guarantee</a>
      </div>
    </footer>
  );
}
